<template>
  <Card v-if="proxyPerson">
    <template slot="header">Modify baxterBucks</template>
    {{ person.firstName }} {{ person.lastName }} ({{ person.personID }}) currently has a ${{ person.baxterBucks }} credit.<br>
    Only use this if you need to adjust user credit directly or issue a refund.
    <form disabled>
      <v-layout
        justify-space-between
        row
      >
        <v-select
          v-model="form.action"
          :items="action"
          label="Action"
          class="px-2"
        />
        <v-text-field
          v-model="form.note"
          label="note"
        />
        <v-currency-field
          v-model="form.amount"
          label="Amount"
          class="px-2"
        />
        <v-btn
          @click="submit()"
        >
          Submit
        </v-btn>
      </v-layout>
    </form>
  </Card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      form: {
        action: null,
        note: null,
        amount: null
      },
      action: [
        'Add',
        'Subtract',
        'Refund'
      ]
    }
  },
  computed: {
    ...mapGetters({
      person: 'person/person',
      proxyPerson: 'person/proxyPerson'
    })
  },
  methods: {
    ...mapActions({
      createBaxterBucksAdjustment: 'invoices/createBaxterBucksAdjustment',
      createRefund: 'invoices/createRefund'
    }),
    submit () {
      let confirmed = confirm("Are you sure? This action can't be undone.")
      if (confirmed) {
        if (this.form.action === 'Refund') {
          this.createRefund(this.form)
        } else {
          this.adjustment()
        }
      }
    },
    adjustment () {
      let data = this.form
      if (this.form.action === 'Add') {
        data = {
          ...data,
          'credit': data.amount,
          'debit': 0.00
        }
      } else {
        data = {
          ...data,
          'credit': 0.00,
          'debit': data.amount
        }
      }
      this.createBaxterBucksAdjustment(data)
    }
  }
}
</script>
